import { Checkbox } from "@/components/core/forms/checkbox";
import { CheckboxGroup } from "@/components/core/forms/checkbox-group";
import { Form } from "@/components/core/forms/form.tsx";
import {
	FormControl,
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
// import { queryClient } from "@/query-client";
import { useCaseRecordStatusMutation } from "@/features/case-record/api/queries/case-records-query";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "./core/buttons/button";

export default function CaseClassificationModal({
	data,
}: { data: CaseRecord }) {
	const navigate = useNavigate();
	const { closeModal } = useModalControl();
	const [isRemoveDeferredChecked, setIsRemoveDeferredChecked] = useState(false);

	const caseRecordStatusMutation = useCaseRecordStatusMutation(data?.id);

	const handleRemoveDeferredChange = (checked: boolean) => {
		setIsRemoveDeferredChecked(checked);
	};

	const handleSubmit = async (values: CaseRecord) => {
		await caseRecordStatusMutation.mutateAsync(values);
		if (form.getValues("for_raffling") === true) {
			navigate({
				to: `/raffle/create/${data.id}`,
			});
		}
		closeModal();
	};

	const status = data.status;

	const form = useForm({
		defaultValues: {
			id: data.id,
			for_raffling: true,
			status: "for_raffling",
		},
	});

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="flex flex-col w-full col-span-12">
					{status === "pending" ? (
						<span>This will redirect you to the raffle page.</span>
					) : (
						<>
							<FormItem>
								<CheckboxGroup>
									<FormItem>
										<FormGroup>
											<div className="flex flex-row w-full gap-2">
												<FormControl>
													<Checkbox
														onCheckedChange={handleRemoveDeferredChange}
													/>
												</FormControl>
												<FormLabel>
													<div className="flex flex-col w-full">
														<span className="text-base text-foreground">
															Remove Deferred Raffling
														</span>
														<span className="text-sm text-muted-foreground">
															This will remove deferred
														</span>
													</div>
												</FormLabel>
											</div>
										</FormGroup>
										<FormMessage />
									</FormItem>
								</CheckboxGroup>
								<FormMessage />
							</FormItem>

							{isRemoveDeferredChecked && (
								<FormItem className="pt-3">
									<CheckboxGroup>
										<FormItem>
											<FormGroup>
												<div className="flex flex-row w-full gap-2">
													<FormControl>
														<Checkbox checked />
													</FormControl>
													<FormLabel>
														<div className="flex flex-col w-full">
															<span className="text-base text-foreground">
																For Raffling
															</span>
															<span className="text-sm text-muted-foreground">
																This will redirect you to the raffle
															</span>
														</div>
													</FormLabel>
												</div>
											</FormGroup>
											<FormMessage />
										</FormItem>
									</CheckboxGroup>
									<FormMessage />
								</FormItem>
							)}
						</>
					)}
				</div>
				<div className="flex flex-row w-full gap-2 mt-4">
					<Button className="" variant="secondary">
						Confirm
					</Button>
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
				</div>
			</form>
		</Form>
	);
}
